<h3 class="text-center">{{ updating ? 'Modification de la période' : 'Nouvelle période' }}</h3>
<form [formGroup]="periodForm" (ngSubmit)="onSubmit()">
  <ng-container>
    <div class="row" id="info">
      <div class="col-sm-6">
        <div id="date" class="field">
          <label for="date-field">Date de début de la période :</label>
          <div class="input-group">
            <input class="form-control"
              id="date-start-field" placeholder="jj/mm/aaaa" name="startDatePeriod"
              autocomplete="false"
              ngbDatepicker #startDatePeriod="ngbDatepicker" (click)="startDatePeriod.toggle()" formControlName="startDatePeriod"/>
            <button class="btn btn-outline-secondary" (click)="startDatePeriod.toggle()" type="button">
              <fa-icon [icon]="faCalendar"></fa-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div id="date2" class="field">
          <label for="date-field">Date de fin de la période :</label>
          <div class="input-group">
            <input class="form-control"
              id="date-field" placeholder="jj/mm/aaaa" name="endDatePeriod"
              autocomplete="false"
              ngbDatepicker #endDatePeriod="ngbDatepicker" (click)="endDatePeriod.toggle()" formControlName="endDatePeriod"/>
            <button class="btn btn-outline-secondary" (click)="endDatePeriod.toggle()" type="button">
              <fa-icon [icon]="faCalendar"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div id="submit" class="text-center">
    @if (periodForm.valid) {
      <button class="btn btn-lg btn-orange" type="submit" [disabled]="submitting"
        [@fadeInUpOnEnter]>
        @if (!submitting) {
          <span>Valider</span>
        }
        @if (submitting) {
          <fa-icon [icon]="faCircleNotch" animation="spin"></fa-icon>
        }
      </button>
    }
  </div>
</form>
